import { EventEmitter } from "nate-react-api-helpers";
import {DrawFrmApp} from "./DrawFrmApp";
import {PropsWithChildren, useEffect, useState} from "react";
import React from "react";
import { Popover } from "@mui/material";

type VisItem = ShowReactInput & {
    key: string;
}

export class DrawFrmReactManager {
    app: DrawFrmApp;
    visible: VisItem[] = [];
    renderEmit: EventEmitter<any>;
    counter: number = 0;

    constructor(app: DrawFrmApp) {
        this.app = app;
        this.renderEmit = new EventEmitter<number>();
        const self = this;
        this.app.opts.onShowReact(() => <DrawFrmDisplay app={self.app} manager={self} />);
    }

    showReact(input: ShowReactInput) {
        const obj = {
            key: (this.counter++).toString(),
            ...input
        };

        this.visible.push(obj);
        this.renderEmit.emit(Date.now());

        return {
            remove: () => this.removeItem(obj)
        }
    }

    removeItem(input: VisItem) {
        this.visible.splice(this.visible.indexOf(input), 1);
        input.onClose?.();
        this.renderEmit.emit(Date.now());
    }

    destroy() {
        this.app.opts.onHideReact();
    }
}

export type ShowReactInput = {
    render: (opts: {
        remove(): void;
    }) => any,
    cover?: boolean
    onClose?: () => void,
    anchor?: AnchorLookup;
};

type AnchorLookup = () => {x: number, y: number} | undefined;

export function DrawFrmDisplay(props: {
    app: DrawFrmApp;
    manager: DrawFrmReactManager;
}) {
    const manager = props.manager;
    const setDate = useState(0)[1];
    const [watch, setWatch] = useState<AnchorLookup[]>([]);

    useEffect(() => {
        const sub = manager.renderEmit.subscribe(() => {
            setDate(Date.now())
            setWatch(manager.visible.map(v => v.anchor).filter(v => v !== undefined))
        });

        return () => {
            sub.cancel();
        }
    }, [manager, setDate]);


    useEffect(() => {
        if(watch.length === 0) return;

        const getWatchValues = () => {
            return watch.map(w => {
                const v = w();
                if(!v) return "";
                return `${v.x}px ${v.y}px`;
            })
        }

        let last = getWatchValues();

        const int = setInterval(() => {
            const have = getWatchValues();

            if(have.join(" ") !== last.join(" ")) {
                last = have;
                setDate(Date.now()); // Trigger re-render
            }
        }, 200);

        return () => clearInterval(int);
    }, [watch, setDate]);

    if(manager.visible.length === 0) return null;

    return (
        <div className="drawfrm-react">
            {manager.visible.map((input, i) => {
                const props2 = {
                    remove: () => manager.removeItem(input),
                }

                const anchor = input.anchor?.();
                let top = "0px";
                let left = "0px";

                if(!anchor) {
                    top = "0px";
                    left = "0px";
                } else {
                    top = `${anchor.y}px`;
                    left = `${anchor.x}px`;
                }

                const El = input.render;

                if(input.cover) {
                    return (
                        <MyPopover top={top} left={left} onClose={props2.remove}>
                            <El {...props2} />
                        </MyPopover>
                    )
                }

                return (
                    <div key={input.key} style={{
                        top, left,
                        position: "absolute",
                        zIndex: 1
                    }}>
                        <El {...props2} />
                    </div>
                )
            })}
        </div>
    )
}

export function MyPopover(props: PropsWithChildren<{
    top: string;
    left: string;
    onClose?: () => void;
}>) {
    const [anchor, setAnchor] = useState<any>(null);

    return (
        <>
            <div ref={setAnchor} style={{
                top: props.top,
                left: props.left,
                position: "absolute",
            }}></div>

            <Popover open onClose={props.onClose} anchorEl={anchor} slotProps={{
                paper: {
                    sx: {
                        background: "none",
                        boxShadow: "none",
                    }
                },
            }}>
                {props.children}
            </Popover>
        </>
    )
}